import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { finalize } from 'rxjs/operators';
import { LayoutService } from "../../../../../core";
import { Observable, Subscription } from "rxjs";
import { UserModel } from "../../../../../../modules/auth/_models/user.model";
import { AuthService } from "../../../../../../modules/auth/_services/auth.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { Router } from "@angular/router";
import { UsuarioService } from "src/app/services/usuario.service";
import { Usuario } from "src/app/models/Usuario/Usuario";
import Swal from "sweetalert2";
import { PlanUsuario } from "src/app/models/PlanesUsuario/PlanUsuario";
import { SessionUser } from "src/app/shared/models/sessionUser";
import { ChangeCompanyService } from "src/app/services/changecompany.service";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { LocalStorage } from "@ng-idle/core";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
import { EmisorService } from "src/app/services/emisor.service";
import { LogoEmisor } from "src/app/models/Emisor/LogoEmisor";
import { PlantillaImpresion } from "src/app/models/PlantillaImpresion/PlantillaImpresion";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LogoUploaderModalComponent } from "src/app/components/layout/logo-uploader-modal/logo-uploader-modal.component";
import { PermissionService } from "src/app/services/permission.service";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';


@Component({
	selector: "app-user-offcanvas",
	templateUrl: "./user-offcanvas.component.html",
	styleUrls: ["./user-offcanvas.component.scss"],
})
export class UserOffcanvasComponent implements OnInit, AfterViewInit, OnDestroy {
	public loading = false;
	extrasUserOffcanvasDirection = "offcanvas-right";
	public _user: Usuario = new Usuario();
	public _userSession: SessionUser;
	public emisor: Emisor;
	msalUserLogged: boolean = false;

	private subscriptionChangeEnvironment: Subscription;

	private currentUserId: string = this.tokenService.getUser().id;
	public hasReseller: boolean = this.tokenService.userHasReseller();
	public planActivo: PlanUsuario;
	public logoError: boolean = false;
	public emisorToEdit: Emisor = new Emisor();
	public emisorToAdd: Emisor = new Emisor();
	public logoEmisorToEdit: LogoEmisor = undefined;


	constructor(private layout: LayoutService, private localStorage: LocalStorageService, 
		private changeCompanyService: ChangeCompanyService, private auth: AuthService, 
		private tokenService: TokenStorageService, private router: Router,
		private emisorService: EmisorService,
		private ref: ChangeDetectorRef,
		private modalService: NgbModal,
		private tokenStorage: TokenStorageService,
		public permissions: PermissionService,
		private planUsuarioService: PlanUsuarioService,
		private sessionUserService: SessionUserService) {}
	ngAfterViewInit(): void {
		this.emisor = (JSON.parse(this.localStorage.getEmisores()) as Emisor[]).find((em) => em.emisorId == this.tokenService.getCompany());
		this.extrasUserOffcanvasDirection = `offcanvas-${this.layout.getProp("extras.user.offcanvas.direction")}`;
		this._user = this.localStorage.getListaUsuarios().find((u) => u.usuarioId == this.currentUserId);
		this._userSession = this.tokenService.getUser() as SessionUser;
	 	this.planActivo = this.planUsuarioService.getActualPlan();
		this.loadLogo();
		this.subscriptionChangeEnvironment = this.localStorage.environmentChanged.subscribe((newEnvironment) => {
			this.emisor.ambiente = newEnvironment;
		});
	}

	ngOnDestroy(): void {
		// Asegúrate de des-suscribirte del observable para prevenir pérdidas de memoria
		this.subscriptionChangeEnvironment.unsubscribe();
	}

	

	// ngOnDestroy(): void {
	// 	this.changeCompanyService.companyChanged.unsubscribe();
	// }
	ngOnInit(): void {
		this.sessionUserService.verificarSesionUsuario();
		this.changeCompanyService.companyChanged.subscribe((newEmisor: Emisor) => {
			this.emisor = newEmisor;
			this.planActivo = this.planUsuarioService.getActualPlan();
			this.loadLogo();
		});
	}

	logout(): void {
		this.loading = true;
		this.ref.detectChanges();
		this.auth
		  .logout()
		  .pipe(
			finalize(() => {
			  this.loading = false;
			  this.ref.detectChanges();
			})
		  )
		  .subscribe(
			(response) => {
			  console.log('Sesión cerrada con éxito', response);
			},
			(error) => {
			  console.error('Error cerrando sesión', error);
			}
		  );
	  }
	  
	  
	  
	  

	externalLogout() {
		this.tokenService.signOut();
		this.tokenService.msalLogout();
	}
	loadLogo(): void {
		if (this.emisor.logo == null || this.emisor.logo == "") {
			this.emisorService.getLogo(this.emisor.emisorId).subscribe((data) => {
			this.emisor.logo = data.data;
			this.ref.detectChanges();
			});
		}
	}
	goToMiCuenta() {
		this.sessionUserService.verificarSesionUsuario();
		this.router.navigateByUrl("/mi-cuenta", {
			state: { userId: this.currentUserId },
		});
	}

	goToCompanyProfile() {
		this.sessionUserService.verificarSesionUsuario();
		this.router.navigateByUrl("/empresa", {
			state: { userId: this.currentUserId },
		});
	}

	goToAccount() {
		this.sessionUserService.verificarSesionUsuario();
		this.router.navigateByUrl("/plan", {
			state: { userId: this.currentUserId },
		});
	}
	handleImageError() {
		this.logoError = true;
	}
	openEmisorLogosList(){
		this.loading = true;
		this.ref.detectChanges();
		this.emisorToEdit = this.emisor;
		this.emisorService.getTipoPlantillasDisponibles(this.emisorToEdit).subscribe({
			next: (plantillasResult) => {
				this.emisorToEdit.plantillasPdfOfEmisor = plantillasResult.data as PlantillaImpresion[];
				this.ref.detectChanges();
				this.loading = false;
				const modalRef = this.modalService.open(LogoUploaderModalComponent, {
					size: 'lg',
					centered: true
				});
				modalRef.componentInstance.relatedEmisor = this.emisorToEdit;
				modalRef.componentInstance.currentLogoEmisor = this.logoEmisorToEdit;
				modalRef.componentInstance.logoUploaded.subscribe((nuevoLogoBase64: string) => {
					this.emisor.logo = nuevoLogoBase64;				
					this.logoError = false;
					this.ref.detectChanges();
				});
				this.ref.detectChanges();
				},
			error: (err) => {
				this.loading = false;
				Swal.fire('Error al obtener plantillas', 'Ha ocurrido un error al obtener las plantillas', 'error');
			}
		});
			  
	}
	
}
